import { useState, useCallback } from 'react';
import useCrmStore from '../stores/crmStore';
import { X, UserPlus } from 'lucide-react';

const ORIGENES = ['Referido', 'Redes sociales', 'Pagina web', 'Evento', 'Llamada entrante', 'WhatsApp', 'Otro'];

function FormRow({ children }) {
  return <div className="form-row">{children}</div>;
}

function FormField({ label, required, children }) {
  return (
    <div className="form-group">
      <label>{label}{required && ' *'}</label>
      {children}
    </div>
  );
}

export default function NewLeadModal({ onClose, onCreated }) {
  const createLead = useCrmStore(s => s.createLead);
  const [form, setForm] = useState({
    nombre: '', apellido: '', cedula: '', telefono: '', email: '', origen: 'Referido', modelo_interes: '', monto_estimado: '', notas: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = useCallback((key, val) => setForm(f => ({ ...f, [key]: val })), []);

  const validate = useCallback(() => {
    if (!form.nombre.trim() || !form.apellido.trim() || !form.cedula.trim() || !form.telefono.trim()) {
      return 'Nombre, Apellido, Cedula y Telefono son obligatorios';
    }
    return null;
  }, [form.nombre, form.apellido, form.cedula, form.telefono]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const validationError = validate();
    if (validationError) { setError(validationError); return; }
    setLoading(true);
    try {
      await createLead({ ...form, monto_estimado: parseFloat(form.monto_estimado) || 0 });
      if (onCreated) onCreated();
      onClose();
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Error al crear lead');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="new-lead-modal" className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-wide" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2><UserPlus size={20} /> Nuevo Lead</h2>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>
        {error && <div className="modal-error">{error}</div>}
        <form onSubmit={handleSubmit} className="new-lead-form">
          <FormRow>
            <FormField label="Nombre" required><input data-testid="new-lead-nombre" value={form.nombre} onChange={e => set('nombre', e.target.value)} required /></FormField>
            <FormField label="Apellido" required><input data-testid="new-lead-apellido" value={form.apellido} onChange={e => set('apellido', e.target.value)} required /></FormField>
          </FormRow>
          <FormRow>
            <FormField label="Cedula" required><input data-testid="new-lead-cedula" value={form.cedula} onChange={e => set('cedula', e.target.value)} placeholder="V-12345678" required /></FormField>
            <FormField label="Telefono" required><input data-testid="new-lead-telefono" value={form.telefono} onChange={e => set('telefono', e.target.value)} placeholder="+58 414-1234567" required /></FormField>
          </FormRow>
          <FormRow>
            <FormField label="Email"><input data-testid="new-lead-email" type="email" value={form.email} onChange={e => set('email', e.target.value)} /></FormField>
            <FormField label="Origen">
              <select data-testid="new-lead-origen" value={form.origen} onChange={e => set('origen', e.target.value)}>
                {ORIGENES.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            </FormField>
          </FormRow>
          <FormRow>
            <FormField label="Modelo de interes"><input data-testid="new-lead-modelo" value={form.modelo_interes} onChange={e => set('modelo_interes', e.target.value)} /></FormField>
            <FormField label="Monto estimado ($)"><input data-testid="new-lead-monto" type="number" value={form.monto_estimado} onChange={e => set('monto_estimado', e.target.value)} /></FormField>
          </FormRow>
          <FormField label="Notas"><textarea data-testid="new-lead-notas" value={form.notas} onChange={e => set('notas', e.target.value)} rows={2} /></FormField>
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancelar</button>
            <button data-testid="submit-new-lead" type="submit" className="btn-primary" disabled={loading}>{loading ? 'Creando...' : 'Crear Lead'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
